import { FC } from 'react';
import { COLORS } from '@connect-x-app/shared-ui';

import styles from './Divider.module.scss';

type Props = {
  color?: string;
  height?: number;
};
export const Divider: FC<Props> = ({ color = COLORS.zulu.$03, height = 2 }) => (
  <hr className={styles['divider']} style={{ borderColor: color, height: `${height}rem` }} />
);
